import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FaqsModule } from '@suvo/frontend-framework/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/shared/faqs/faqs.module';
import { ListNavigationModule } from '@suvo/frontend-framework/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/list-navigation/list-navigation.module';
import { AuthenticationModule } from '@suvo/frontend-framework/SUVO-USERS-CLIENT-LIB/projects/suvo-users-client-lib/src/lib/features/authentication/modules/authentication/authentication.module';
import { SharedModule } from '../../shared/shared.module';
import { EmailVerificationMessageComponent } from './components/email-verification-message/email-verification-message.component';
import { FooterComponent } from './components/footer/footer.component';
import { LoginComponent } from './components/login/login.component';
import { NavigationToolbarComponent } from './components/navigation-toolbar/navigation-toolbar.component';
import { PublicLanguageSelect } from './components/public-language-select.component';
import { TitleSmallSectionComponent } from './components/title-small-section/title-small-section.component';
import { FaqsScreenComponent } from './screens/faqs-screen/faqs-screen.component';
import { IdentityComponent } from './screens/identity/identity.component';
import { PricingComponent } from './screens/pricing/pricing.component';
import { PrivacyPolicyComponent } from './screens/privacy-policy/privacy-policy.component';
import { RegisterComponent } from './screens/register/register.component';
import { ResetPasswordConfirmationScreenComponent } from './screens/reset-password-confirmation-screen/reset-password-confirmation-screen.component';
import { TermsAndConditionsComponent } from './screens/terms/terms-and-conditions.component';
import { VerifyComponent } from './screens/verify/verify.component';
import { VerifyEmailConfirmationScreenComponent } from './screens/verify-email/verify-email-confirmation-screen.component';
import { PublicComponent } from './public.component';

@NgModule({
  declarations: [
    PublicComponent,
    VerifyComponent,
    EmailVerificationMessageComponent,
    RegisterComponent,
    PricingComponent,
    NavigationToolbarComponent,
    FooterComponent,
    IdentityComponent,
    PrivacyPolicyComponent,
    TitleSmallSectionComponent,
    LoginComponent,
    TermsAndConditionsComponent,
    FaqsScreenComponent,
    VerifyEmailConfirmationScreenComponent,
    ResetPasswordConfirmationScreenComponent,
  ],
  imports: [
    AuthenticationModule,
    SharedModule,
    CommonModule,
    ListNavigationModule,
    FaqsModule,
    // PublicLanguageSelect,
  ],
})
export class PublicModule {}
